// extracted by mini-css-extract-plugin
export default {"wrapper":"aj-z","reviewFormSuccess":"bj-z","header":"cj-z","message":"dj-z","paragraph":"ej-z","lottieContainer":"fj-z"};